import { createContext } from 'react';
import _noop from 'lodash/noop';

import { initialContext } from './constants';

export const GapAnalysisToolsContext =
    createContext<GapAnalysisToolsProviderValue>({
        analyzeTrqkGap: () => Promise.resolve(false),
        context: initialContext,
        deleteGapAnalysis: () => Promise.resolve(''),
        exportGapAnalysis: () => Promise.resolve(null),
        exportingGapAnalysisIds: [],
        exportingGapAnalysisIdsWithFilename: [],
        fetchAndSetChannels: () => Promise.resolve(null),
        fetchAndSetTrqkGap: () => Promise.resolve(null),
        fetchAndUpdateAudioLists: () => Promise.resolve(null),
        fetchGapReportAudios: () => Promise.resolve(null),
        fetchGapSummaries: () => Promise.resolve(true),
        fetchPeriodSelections: _noop,
        gapSummaries: [],
        gapSummariesRefreshTime: 0,
        openManageGapAnalysis: _noop,
        openViewGapAnalysis: _noop,
        send: _noop,
        startGapAnalysisEdit: _noop,
    });
